import React from 'react';
import { Link } from 'react-router-dom';

import './../../pagescss/Subjects.css';
import subjects from './Subjects';
import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';


function QuizSubjectPage(props) {

    return (
        <div className="subject-page">

            <TopNavbar name="Mock test" />
            <TopHeader name="Mock test" />









            <div className="subject-categories">

                <Link to={`/quiz-number/${props.type}/${props.subject}/${props.topic}/${props.subjectName}`}
                    className="subject-card"
                    style={{ borderLeft: `5px solid green` }}
                >


                    <div className="subject-card-row">
                        <div className="subject-card-icon">
                            <span style={{ fontSize: '50px', lineHeight: 1 }}>
                                Δ
                            </span>
                        </div>
                        <h3>Full mock test →</h3>
                    </div>

                </Link>

                {subjects.map((subject) => (
                    <Link
                        to={`/${props.link}/${subject.name.toLowerCase().replace(' ', '-')}`}
                        key={subject.id}
                        className="subject-card"
                        style={{ borderLeft: `5px solid ${subject.color}` }}
                    >
                        <div className="subject-card-row">
                            <div className="subject-card-icon">
                                <span style={{ fontSize: '50px', lineHeight: 1 }}>
                                    {subject.icon}
                                </span>
                            </div>
                            <h3>{subject.name} →</h3>
                        </div>

                    </Link>
                ))}
            </div>
        </div>


    );
}

export default QuizSubjectPage;